import { createContext, PropsWithChildren, useState } from 'react';

import { ErrorDialog } from 'pkg/components/ErrorHandling/ErrorDialog';

export const AlertsContext = createContext<{
  setError: (error: string[]) => void;
}>({ setError: () => {} });

export const AlertsProvider = ({ children }: PropsWithChildren<{}>): JSX.Element => {
  const [errors, setError] = useState<string[]>([]);

  return (
    <AlertsContext.Provider value={{ setError }}>
      {children}
      {Boolean(errors.length) && <ErrorDialog onClose={() => setError([])} />}
    </AlertsContext.Provider>
  );
};
